(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gf-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if(customElements.get('gf-currency')) return;
  const preferenceKey='gf-display-currency-v1', rateKey='gf-display-rates-v1', day=86400000;
  let currency='ALL', rateData=null, request=null, serial=0, pending=new Set(), frame=0;
  const formatters={EUR:new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'EUR',currencyDisplay:'code'}),USD:new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'USD',currencyDisplay:'code'})};
  const stored=(key)=>{try{return localStorage.getItem(key);}catch{return null;}};
  const persist=(key,value)=>{try{localStorage.setItem(key,value);}catch{}};
  const valid=(data)=>{
    if(!data||!/^\d{4}-\d{2}-\d{2}$/.test(data.date||'')) return false;
    const age=Date.now()-Date.parse(data.date+'T00:00:00Z');
    return Number.isFinite(age)&&age>=-day&&age<=7*day&&['EUR','USD'].every(code=>Number.isFinite(data.rates?.[code])&&data.rates[code]>0&&data.rates[code]<1);
  };
  async function rates(control){
    if(valid(rateData)) return rateData;
    let cached;try{cached=JSON.parse(stored(rateKey));}catch{}
    if(valid(cached)&&Date.now()-cached.fetchedAt<day){rateData=cached;return cached;}
    if(request) return request;
    request=(async()=>{
      const abort=new AbortController(), timeout=setTimeout(()=>abort.abort(),4000);
      try{
        const response=await fetch('https://api.frankfurter.dev/v2/rates?base=ALL&quotes=EUR,USD',{credentials:'omit',referrerPolicy:'no-referrer',signal:abort.signal});
        if(!response.ok) throw Error('rates');
        const rows=await response.json();
        if(!Array.isArray(rows)) throw Error('rates');
        const selected=['EUR','USD'].map(code=>rows.find(row=>row.base==='ALL'&&row.quote===code));
        if(selected.some(row=>!row)) throw Error('rates');
        const next={date:selected.map(row=>row.date).sort()[0],rates:Object.fromEntries(selected.map(row=>[row.quote,Number(row.rate)])),fetchedAt:Date.now(),source:'Frankfurter'};
        if(!valid(next)) throw Error('rates');
        rateData=next;persist(rateKey,JSON.stringify(next));return next;
      }catch{
        const fallback={date:control.dataset.fallbackDate,rates:{EUR:1/Number(control.dataset.fallbackEur),USD:1/Number(control.dataset.fallbackUsd)},source:'Bank of Albania'};
        const candidates=[cached,fallback].filter(valid).sort((a,b)=>b.date.localeCompare(a.date));
        if(!candidates.length) throw Error('unavailable');
        rateData=candidates[0];return rateData;
      }finally{clearTimeout(timeout);request=null;}
    })();
    return request;
  }
  function applyPrice(element){
    if(!element.isConnected) return;
    const raw=element.dataset.gfCents;
    if(raw===''||!Number.isFinite(Number(raw))) return;
    if(currency==='ALL'){
      if(element.dataset.gfOriginal!==undefined){element.textContent=element.dataset.gfOriginal;delete element.dataset.gfOriginal;}
      delete element.dataset.gfDisplay;
      return;
    }
    if(!rateData) return;
    if(element.dataset.gfOriginal===undefined) element.dataset.gfOriginal=element.textContent;
    const value=(element.dataset.gfPrefix||'')+formatters[currency].format(Number(raw)/100*rateData.rates[currency]);
    if(element.textContent!==value) element.textContent=value;
    element.dataset.gfDisplay=currency;
  }
  function collect(root){
    if(root.nodeType!==1&&root.nodeType!==9) return;
    if(root.matches?.('[data-gf-cents]')) pending.add(root);
    for(const element of root.querySelectorAll('[data-gf-cents]')) pending.add(element);
    if(!frame&&pending.size) frame=requestAnimationFrame(flush);
  }
  function flush(){
    frame=0;observer.disconnect();
    let count=0;
    for(const element of pending){pending.delete(element);applyPrice(element);if(++count===80) break;}
    for(const note of document.querySelectorAll('.gf-currency-checkout-note')) note.hidden=currency==='ALL';
    if(currency!=='ALL') observe();
    if(pending.size) frame=requestAnimationFrame(flush);
  }
  const observer=new MutationObserver(records=>{
    for(const record of records){
      if(record.type==='attributes') collect(record.target);
      else{
        if(record.target.matches?.('[data-gf-cents]')) collect(record.target);
        for(const node of record.addedNodes) collect(node);
      }
    }
  });
  function observe(){observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-gf-cents']});}
  function syncControls(message=''){
    for(const control of document.querySelectorAll('gf-currency')){
      control.querySelector('select').value=currency;
      control.querySelector('[data-gf-currency-code]').textContent=currency;
      control.querySelector('[data-gf-currency-status]').textContent=message;
      control.querySelector('[data-gf-rate-date]').textContent=currency!=='ALL'&&rateData?control.dataset.rateLabel+': '+rateData.date:'';
      control.dataset.rateSource=currency!=='ALL'&&rateData?rateData.source:'';
    }
  }
  async function choose(code,control){
    const attempt=++serial;
    if(!['ALL','EUR','USD'].includes(code)) return;
    if(code!=='ALL'){
      control.querySelector('[data-gf-currency-status]').textContent=control.dataset.loading;
      try{await rates(control);}catch{
        if(attempt!==serial) return;
        currency='ALL';persist(preferenceKey,'ALL');observer.disconnect();collect(document);syncControls(control.dataset.unavailable);return;
      }
    }
    if(attempt!==serial) return;
    currency=code;persist(preferenceKey,code);observer.disconnect();collect(document);syncControls();
  }
  class GFCurrency extends HTMLElement{
    connectedCallback(){
      const select=this.querySelector('select');if(!select) return;
      this.abort=new AbortController();const signal=this.abort.signal;
      select.disabled=false;
      select.addEventListener('change',()=>choose(select.value,this),{signal});
      const menu=this.querySelector('details');
      if(menu){
        this.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;this.querySelector('summary').focus();}},{signal});
        document.addEventListener('click',event=>{if(!this.contains(event.target))menu.open=false;},{signal});
      }
      const preferred=stored(preferenceKey);
      if(currency==='ALL'&&['EUR','USD'].includes(preferred)) choose(preferred,this);else syncControls();
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  customElements.define('gf-currency',GFCurrency);
})();
  } catch(e) { console.error(e); }
})();

})();
